import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { injectIntl } from 'react-intl';
import Select from 'react-select';
import './IncomingOrdersFilter.css';

const IncomingOrdersFilterReduxForm = ({ intl, ...props }) => {
  const options = [
    { value: 'SHOW_ALL', label: intl.formatMessage({ id: 'orders.all' }) },
    {
      value: 'SHOW_AWAITING_INTERACTION',
      label: intl.formatMessage({ id: 'orders.waiting.interaction' }),
    },
  ];
  return <Field {...props} name="orderType" component={IncomingOrdersFilter} options={options} />;
};

IncomingOrdersFilterReduxForm.propTypes = {
  intl: PropTypes.object.isRequired,
};

const IncomingOrdersFilter = ({ input, options, label }) => (
  <div className="IncomingOrdersFilter">
    <div className="IncomingOrdersFilter__label">{label}</div>
    <Select
      {...input}
      className="IncomingOrdersFilter__dropdown"
      onChange={value => input.onChange(value)}
      onBlur={() => input.onBlur(input.value)}
      options={options}
      isSearchable={false}
      isClearable={false}
    />
  </div>
);

IncomingOrdersFilter.propTypes = {
  label: PropTypes.node.isRequired,
  input: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
};

const intlComponent = injectIntl(IncomingOrdersFilterReduxForm);

export default reduxForm({
  form: '@ORDERS/INCOMING',
  destroyOnUnmount: false,
  initialValues: {
    orderType: {
      value: 'SHOW_ALL',
      label: 'Todos os pedidos',
    },
  },
})(intlComponent);



// WEBPACK FOOTER //
// ./src/modules/orders/components/IncomingOrdersFilter/IncomingOrdersFilter.connect.jsx